import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http") || p.startsWith("data:")) return p;
  if (p.startsWith("/api/")) return `${BACKEND_URL}${p}`;
  return `${API}/files/${p}`;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatError(detail) {
  if (detail == null) return "Jotain meni pieleen. Yritä uudelleen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
